import { API_URLS } from "../../../Configs/apiUrls";
import axiosInstance from "../../../Configs/axios";

export const myAddressList = (redBody) => {
  try {
    const response = axiosInstance.get(API_URLS.addressList, redBody);
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};
